import { gql } from '@apollo/client';

export const adminLeaveTerritoryMutation = gql`
  mutation adminLeaveTerritoryMutation($territoryId: ID!) {
    adminLeaveTerritory(territoryId: $territoryId)
  }
`;
